import React, { Component } from "react";

class RiskAssessment extends Component {
  render() {
    const { possible_score, actual_score, weight_score, config_data } =
      this.props;

    return (
      <div className="row row-xs">
        <div className="col-md-12 mg-t-0 pd-t-0 inspe_hgt">
          <div className="brandList dashboardRightcard d-flex flex-wrap align-items-center p-4 m-0">
            {this.props.config_data.length > 0 ? (
              <>
                <div className="form-group col-md-3 m-0">
                  <label className="form-label text-left">Possible Score</label>
                  <p>{possible_score}</p>
                  <label className="form-label text-left">Actual Score</label>
                  <p>{actual_score}</p>
                  <label className="form-label text-left">
                    Overall Score (%)
                  </label>
                  <p className="m-0">{weight_score}</p>
                </div>
                <RiskLevelGrid config_data={config_data} />
              </>
            ) : (
              <>
                <div className="form-group col-md-4 m-0">
                  <label className="form-label text-left">Possible Score</label>
                  <p>{possible_score}</p>
                </div>
                <div className="form-group col-md-4 m-0">
                  <label className="form-label text-left">Actual Score</label>
                  <p>{actual_score}</p>
                </div>
                <div className="form-group col-md-4 m-0">
                  <label className="form-label text-left">
                    Overall Score (%)
                  </label>
                  <p className="m-0">{weight_score}</p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

class RiskLevelGrid extends Component {
  render() {
    return (
      <div className="col-md-9">
        {this.props.config_data.length > 0 && (
          <div className="risk-level-container text-center">
            <div className="risk-level-grid">
              {/* Header Row */}
              <div className="risk-level-header">
                <div className="risk-col">Risk Level</div>
                <div className="risk-col">Level</div>
                <div className="risk-col">Follow up Site Visit</div>
              </div>

              {/* Data Rows */}
              {this.props.config_data.map((config, index) => (
                <div className="risk-level-row" key={index}>
                  <div className="risk-col">{config.riskLevel}</div>
                  <div
                    className="risk-col"
                    style={{ backgroundColor: config.color }}
                  >
                    {config.level}
                  </div>
                  <div className="risk-col">{config.followUp}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default RiskAssessment;
